import { algebraPill } from './algebra'
import { analysisPill } from './analysis'
import { geometryPill } from './geometry'

export const fieldsTab = {
  tab: 'fields',
  label: '分野別',
  pillData: [algebraPill, analysisPill, geometryPill],
}
